

import isNil from 'lodash.isnil';



import { DATA_TABLE_NO_VALUE } from '../../../../../common/constants/dataTableValues';



export const getDataTableCellRawValue = (
row,
columnField) =>
row[columnField];

export const getDataTableCellValue = (
row,
column,
treeRowNode) =>
{
  const rawValue = getDataTableCellRawValue(row, column.field);
  let value = rawValue;

  if (column.getValue) {
    value = column.getValue(rawValue, row, column, treeRowNode);
  }

  if (isNil(value)) {
    value = DATA_TABLE_NO_VALUE;
  }

  return value;
};